// src/features/changelog/pages/Changelog.jsx
import React, { useState, useEffect } from 'react';
import { useTranslation } from 'react-i18next';
import { Box, CircularProgress, Alert, Stack } from '@mui/material';
import { History as HistoryIcon } from '@mui/icons-material';
import { useChangelog } from '../hooks/useChangelog';
import ReleaseCard from '../components/ReleaseCard';
import PageHeader from '../../../components/common/PageHeader';

export default function ChangelogPage() {
  const { t } = useTranslation(['common']);
  const { releases, loading, error } = useChangelog();
  const [expanded, setExpanded] = useState(null);

  // Expand the latest release by default
  useEffect(() => {
    if (releases.length > 0) setExpanded(releases[0].version);
  }, [releases]);

  const handleChange = (version) => (event, isExpanded) => {
    setExpanded(isExpanded ? version : null);
  };

  if (loading) {
    return (
      <Box display="flex" alignItems="center" justifyContent="center" minHeight="60vh">
        <CircularProgress />
      </Box>
    );
  }

  if (error) {
    return (
      <Box>
        <Alert severity="error">{error}</Alert>
      </Box>
    );
  }

  return (
    <Box>
      <PageHeader
        icon={HistoryIcon}
        title={t('common:changelog.title')}
        subtitle={t('common:changelog.subtitle')}
      />
      {/* Releases */}
      <Stack spacing={1}>
        {releases.map((release, index) => (
          <ReleaseCard
            key={release.version}
            release={release}
            isLatest={index === 0}
            expanded={expanded === release.version}
            onChange={handleChange(release.version)}
          />
        ))}
      </Stack>

      {releases.length === 0 && (
        <Alert severity="info">
          {t('common:changelog.no_entries')}
        </Alert>
      )}
    </Box>
  );
}
